import React from 'react';
import { Handle, Position } from 'reactflow';
import { Database, ArrowRight } from 'lucide-react';

const UpdateDataNode = ({ data, selected }) => {
  const targetEntity = data.target_entity || 'order';
  const targetField = data.target_field || 'delivery_location';
  const sourceField = data.source_field || 'response.location';
  
  const formatFieldName = (field) => {
    return field.split('.').pop().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 min-w-[180px] shadow-lg ${
        selected
          ? 'border-teal-400 bg-teal-500/20'
          : 'border-teal-500/50 bg-slate-800/90'
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 !bg-teal-400"
      />
      
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 rounded-md bg-teal-500/20">
          <Database className="w-4 h-4 text-teal-400" />
        </div>
        <span className="text-xs font-medium text-teal-400 uppercase tracking-wide">
          Update
        </span>
      </div>
      
      <div className="text-sm font-medium text-white truncate">
        {data.label || 'Update Data'}
      </div>
      
      <div className="flex items-center gap-1 mt-2 text-xs text-slate-400">
        <span className="px-1.5 py-0.5 bg-slate-700 rounded text-cyan-300">
          {formatFieldName(sourceField)}
        </span>
        <ArrowRight className="w-3 h-3" />
        <span className="px-1.5 py-0.5 bg-slate-700 rounded text-teal-300">
          {targetEntity}.{formatFieldName(targetField)}
        </span>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="w-3 h-3 !bg-teal-400"
      />
    </div>
  );
};

export default UpdateDataNode;
